<template>
  <img
    :src="src"
    :alt="alt || undefined"
    v-bind="$attrs"
  >
</template>

<script>
export default {
  name: 'CImg',
  inheritAttrs: false,
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
  },
}
</script>
